export default __webpack_public_path__ + "static/media/pgmico(10).e8624f48.png";